const trustItems = [
  { icon: "ri-time-line", value: "21+", label: "Years Experience", sub: "Since 2003" },
  { icon: "ri-medal-line", value: "A+", label: "BBB Rated", sub: "Better Business Bureau" },
  { icon: "ri-star-fill", value: "5.0", label: "Star Rating", sub: "120+ Verified Reviews" },
  { icon: "ri-building-2-line", value: "500+", label: "Projects Done", sub: "Residential & Commercial" },
];

export default function TrustBar() {
  return (
    <section className="relative z-10 bg-stone-950">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-white/10">
          {trustItems.map((item) => (
            <div key={item.label} className="flex items-center gap-4 py-7 px-6 group">
              <div className="w-10 h-10 flex items-center justify-center bg-amber-500/15 rounded-lg flex-shrink-0 group-hover:bg-amber-500/25 transition-colors">
                <i className={`${item.icon} text-amber-400 text-xl`}></i>
              </div>
              <div>
                <div
                  className="text-2xl font-black text-white leading-none"
                  style={{ fontFamily: "'Syne', sans-serif" }}
                >
                  {item.value}
                </div>
                <div className="text-xs font-semibold text-white/60 mt-0.5 uppercase tracking-wide">{item.label}</div>
                <div className="text-xs text-white/35 mt-0.5">{item.sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
